var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
import * as React2 from "react";
import "prop-types";
import { useUID } from "@twilio-paste/uid-library";
import { Box } from "@twilio-paste/box";
import { BaseRadioCheckboxControl, BaseRadioCheckboxLabel, BaseRadioCheckboxLabelText, BaseRadioCheckboxHelpText } from "@twilio-paste/base-radio-checkbox";
import * as React from "react";
var RadioContext = React.createContext({
  name: "",
  value: "",
  disabled: !1,
  hasError: !1,
  onChange: () => {}
});
var HiddenRadio = React2.forwardRef((props, ref) => React2.createElement(Box, __spreadValues({
  as: "input",
  type: "radio",
  size: "size0",
  border: "none",
  overflow: "hidden",
  padding: "space0",
  margin: "space0",
  whiteSpace: "nowrap",
  textTransform: "none",
  position: "absolute",
  clip: "rect(0 0 0 0)",
  ref
}, props)));
HiddenRadio.displayName = "HiddenRadio";
var Radio = React2.forwardRef((_a, ref) => {
  var _b = _a,
    {
      id,
      name,
      element = "RADIO",
      value,
      checked,
      defaultChecked,
      disabled,
      hasError,
      onChange,
      children,
      helpText
    } = _b,
    props = __objRest(_b, ["id", "name", "element", "value", "checked", "defaultChecked", "disabled", "hasError", "onChange", "children", "helpText"]);
  if (checked != null && defaultChecked != null) throw new Error("[Paste Radio] Do not provide both 'defaultChecked' and 'checked' to Radio at the same time. Please consider if you want this component to be controlled or uncontrolled.");
  let radioGroupContext = React2.useContext(RadioContext),
    helpTextId = useUID(),
    radioId = id || useUID(),
    isControlled = React2.useMemo(() => checked !== void 0 || radioGroupContext.value !== "", []),
    handleChange = React2.useCallback(event => {
      onChange ? onChange(event) : radioGroupContext.onChange(event);
    }, [onChange, radioGroupContext.onChange]),
    state = {
      name: name != null ? name : radioGroupContext.name,
      disabled: disabled != null ? disabled : radioGroupContext.disabled,
      hasError: hasError != null ? hasError : radioGroupContext.hasError
    };
  return isControlled ? radioGroupContext.value !== "" ? state.checked = radioGroupContext.value === value : state.checked = checked : state.defaultChecked = defaultChecked, React2.createElement(Box, {
    element,
    position: "relative",
    display: "inline-flex",
    alignItems: "flex-start",
    flexDirection: "column",
    verticalAlign: "top"
  }, React2.createElement(HiddenRadio, __spreadProps(__spreadValues(__spreadValues({}, props), state), {
    value,
    "aria-describedby": helpTextId,
    "aria-invalid": state.hasError,
    onChange: handleChange,
    id: radioId,
    ref
  })), React2.createElement(BaseRadioCheckboxLabel, {
    disabled: state.disabled,
    htmlFor: radioId
  }, React2.createElement(BaseRadioCheckboxControl, {
    element: "".concat(element, "_CONTROL"),
    borderRadius: "borderRadiusCircle",
    disabled: state.disabled,
    type: "radio"
  }, React2.createElement(Box, {
    as: "span",
    element: "".concat(element, "_CONTROL_CIRCLE"),
    lineHeight: "lineHeight0",
    display: "block",
    color: "inherit",
    size: "sizeIcon10"
  }, React2.createElement("svg", {
    role: "img",
    "aria-hidden": !0,
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    fill: "none"
  }, React2.createElement("circle", {
    fill: "currentColor",
    cx: 8,
    cy: 8,
    r: 3
  })))), React2.createElement(BaseRadioCheckboxLabelText, {
    element: "".concat(element, "_LABEL_TEXT")
  }, children)), helpText && React2.createElement(BaseRadioCheckboxHelpText, {
    element: "".concat(element, "_HELP_TEXT_WRAPPER"),
    helpTextId
  }, helpText));
});
Radio.displayName = "Radio";
import * as React3 from "react";
import PropTypes2 from "prop-types";
import { InlineControlGroup } from "@twilio-paste/inline-control-group";
var RadioGroup = React3.forwardRef((_a, ref) => {
  var _b = _a,
    {
      name,
      element = "RADIO_GROUP",
      value,
      onChange,
      disabled = !1,
      errorText,
      children,
      i18nRequiredLabel = "(required)"
    } = _b,
    props = __objRest(_b, ["name", "element", "value", "onChange", "disabled", "errorText", "children", "i18nRequiredLabel"]);
  let onChangeHandler = React3.useCallback(event => {
      onChange != null && onChange(event.target.value);
    }, [onChange]),
    contextValue = React3.useMemo(() => ({
      name,
      value: value || "",
      disabled,
      hasError: errorText != null,
      onChange: onChangeHandler
    }), [name, value, disabled, errorText, onChangeHandler]);
  return React3.createElement(RadioContext.Provider, {
    value: contextValue
  }, React3.createElement(InlineControlGroup, __spreadProps(__spreadValues({
    element
  }, props), {
    disabled,
    errorText,
    name,
    ref,
    i18nRequiredLabel
  }), children));
});
RadioGroup.displayName = "RadioGroup";
RadioGroup.propTypes = {
  name: PropTypes2.string.isRequired,
  onChange: PropTypes2.func,
  value: PropTypes2.string,
  element: PropTypes2.string,
  i18nRequiredLabel: PropTypes2.string
};
export { Radio, RadioGroup };